export default __webpack_public_path__ + "static/media/english-to-korean-screenshot-03.eeadd433.png";